import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LocalstorageService } from './../../core/data/localstorage.service';
import { catchError, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  public baseUrl: string = "https://api.satcom-dev.grtech.io/";
  public npgUrl: string = "https://api.npg-staging.grtech.io/v1/";
  //public baseUrl: string = "http://localhost:420/api/"; // localhost proxy pass for safari
  //public npgUrl: string = "http://localhost:420/npg/"; // localhost proxy pass for safari
  public npgPublicKey: string = "pk_test_P9tDHMeDOxir6kdH2QGxrNIU";
  public httpOptions;
  private token : string;
  private origin: string;
  //public baseUrl: string = "http://localhost:3450/";
  //public npgUrl: string = "http://localhost:8080/v1/";
  //public npgPublicKey: string = "pk_test_NWUQUwOw21LXQGIrY6IKhhmt";
  
  constructor(private http: HttpClient, private localStorageService: LocalstorageService, private snackBar: MatSnackBar,  private router: Router, private jwtHelper: JwtHelperService) {

    this.origin = window.location.origin;
    console.log('origin: ', this.origin);
    this.token = this.localStorageService.accessToken;
    console.log('token in api service: ', this.token);
    this.httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin':'*',
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer ' + this.token
      })
    }
  }

  getBaseUrl(): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin':'*',
        'Content-Type' : 'application/json'
      })
    }
    return this.http
      .get<any>(this.origin + '/api_server', httpOptions)
      .pipe(
        tap((data: any) => 
          {
            console.log('FETCHED BASE URL: ', data);
            this.baseUrl = data.base + '/';
            this.localStorageService.captivePortalBaseUrl = data.captivePortalBase + '/';
            this.npgUrl = data.npgBase + '/';
            this.localStorageService.npgUrl = this.npgUrl;
            this.npgPublicKey = data.npgPublicKey;
            this.localStorageService.npgPublicKey = this.npgPublicKey;
            console.log('NEW BASE URL: ', this.baseUrl);
            this.localStorageService.packagePriceLimit = Number(data.packagePriceLimit);
          }, err => {
            console.log('An error has occured: ', err.error.error.statusCode, ' - ', err.error.error.message);

          }),
          catchError(this.handleError))
  }

  getHttpOptions(){
    this.token = this.localStorageService.accessToken;
    if(!!this.token){
      // check if its expired
      const decodedToken = this.jwtHelper.decodeToken(this.token);
      if(!!decodedToken){
        const exp = decodedToken.exp * 1000;
        const now = new Date().getTime();
        console.log('exp: ', new Date(exp), ' now: ', new Date(now));
        if(exp < now){
          // token is expired
          this.localStorageService.accessToken = undefined;
          localStorage.removeItem('accessToken');
          // refresh the page completely otherwise open forms will stay open
          window.location.href = '/credentials/login';
          //this.router.navigate(['/credentials/login']);
        }
      }
    }
    console.log('token in api service: ', this.token);
    return this.httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin':'*',
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer ' + this.token
      })
    }
  }
  
  handleError(error: HttpErrorResponse) {
    if(error.error){
      if (error.error instanceof ErrorEvent) {
        if(error.error.message){
          console.log('Client side error:', error.error.message);
        }
      } else {
        console.log(
          `Server side error. Backend returned code: ${error.status}, ` +
          `body was: ${error.error}`);
      }
      if(error.status == 401){
        if(this && typeof this.snackBar !== 'undefined'){
          this.snackBar.open('Session Expired. Please Login.', 'Close', {
            duration: 3000,
          });
        }
        if(this.localStorageService){
          this.localStorageService.accessToken = undefined;
        } 
        localStorage.removeItem('accessToken');
        // refresh the page completely otherwise open forms will stay open
        window.location.href = '/credentials/login';
      }else{
        if(this && typeof this.snackBar !== 'undefined'){
          this.snackBar.open('Failed to retrieve data. Please try again later.', 'Close', {
            duration: 3000,
          });
        }
      }
    }
    return throwError(
      // 'Something bad happened; please try again later.');
      error);     
  };

  handleDashboardStylesError(error: HttpErrorResponse){

    if(error.status == 404){
      this.router.navigate(['/404', {op: 0}]);  
    }

    return throwError(error);   
  }

}